import React from "react";
import { motion } from "framer-motion";

import "../styles/AttendanceShowcase.css";

/* EMPLOYEE SCREENSHOT */
import employeeAttendanceImage from "../../../assets/attendance-module.png";

/* MANAGEMENT VIDEO */
import attendanceManagementVideo from "../../../assets/attendance-management-demooo.mp4";

const AttendanceShowcase = () => {
  return (

    <section className="attendance-showcase-section">

      {/* LEFT SIDE */}

      <motion.div
        className="attendance-showcase-left"
        initial={{ opacity: 0, x: -80 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >

        {/* EMPLOYEE VIEW */}

        <div className="attendance-image-card employee-view-card">

          <div className="attendance-image-header">
            Employee View
          </div>

          <img
            src={employeeAttendanceImage}
            alt="employee attendance"
            className="attendance-showcase-image"
            style={{ imageRendering: "-webkit-optimize-contrast" }}
          />

        </div>

        {/* MANAGEMENT VIDEO */}

        <div className="attendance-image-card management-view-card">

          <div className="attendance-image-header">
            Management Dashboard Demo
          </div>

          <video
            className="attendance-showcase-video"
            autoPlay
            muted
            loop
            playsInline
          >

            <source
              src={attendanceManagementVideo}
              type="video/mp4"
            />

          </video>

        </div>

      </motion.div>

      {/* RIGHT CONTENT */}

      <motion.div
        className="attendance-showcase-right"
        initial={{ opacity: 0, x: 80 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >

        <p className="attendance-mini-title">
  ATTENDANCE MANAGEMENT
</p>

<h2 className="attendance-main-title">
  Real-Time Attendance <br />
  Monitoring & Tracking
</h2>

<p className="attendance-description">
  Monitor employee attendance, punch-in records,
 leave applications,
  WFH requests, probation policy rules.
</p>

<div className="attendance-feature-list">

  <div className="attendance-feature-item">
    ✓ Live Attendance Tracking
  </div>

  

  <div className="attendance-feature-item">
    ✓ Leave Application & Approval
  </div>

  <div className="attendance-feature-item">
    ✓ Leave Request Email Notifications
  </div>

  <div className="attendance-feature-item">
    ✓ Leave Approval / Rejection Email Alerts
  </div>

  <div className="attendance-feature-item">
    ✓ Probation Policy Management
  </div>

  <div className="attendance-feature-item">
    ✓ Leave Type Conversion
  </div>

  <div className="attendance-feature-item">
    ✓ WFH Request Management
  </div>

  <div className="attendance-feature-item">
    ✓ Employee & Admin Views
  </div>

</div>

      </motion.div>

    </section>

  );
};

export default AttendanceShowcase;














